import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { arrayPush, change, touch } from 'redux-form/immutable';

// components
import Holiday from './_Holiday';
import { FormSection } from 'redux-form/immutable';

class HolidayForm extends React.Component {
  static propTypes = {
    form:       PropTypes.string.isRequired,
    formValues: PropTypes.instanceOf(Immutable.Map)
  }

  render() {
    return (
      <div className='holidays'>
        { this._renderHolidays() }
        <div className='holiday__add'>
          <a href='#' onClick={ this._handleAdd }>+ Add Date</a>
        </div>
      </div>
    );
  }

  // private

  _handleAdd = this._handleAdd.bind(this);

  _handleAdd(e) {
    e.preventDefault();

    this.props.dispatch(arrayPush(this.props.form, 'office.holidays', Immutable.fromJS({ month: null, day: null })));
  }

  _renderHolidays() {
    const components = [];
    const form       = this.props.form;
    const formValues = this.props.formValues || Immutable.Map();
    const holidays   = formValues.getIn(['office', 'holidays']) || Immutable.List();

    holidays.forEach((holiday, i) => {
      const day      = parseInt(holiday.get('day'), 10);
      const month    = parseInt(holiday.get('month'), 10);
      const name     = 'office.holidays';
      const hasError = holiday.get('hasError');

      components.push(
        <FormSection key={ i } name={ `${name}[${i}]` }>
          <Holiday day={ day }
            disableDay={ !month }
            form={ form }
            hasError={ hasError }
            key={ i }
            month={ month }
            name={ name }
            position={ i } />
        </FormSection>
      );
    });

    return components;
  }
}

HolidayForm.validate = function({ dispatch, form, formValues = Immutable.Map() }) {
  const holidays = formValues.getIn(['office', 'holidays']) || Immutable.List();

  let hasError = false;

  holidays.forEach((holiday, i) => {
    const day   = holiday.get('day');
    const month = holiday.get('month');
    const path  = `office.holidays[${i}].hasError`;

    if (month && day) {
      dispatch(touch(form, path));
      dispatch(change(form, path, false));
    } else {
      hasError = true;

      dispatch(change(form, path, true));
    }
  });

  return !hasError;
};

export default connect()(HolidayForm);



// WEBPACK FOOTER //
// ./app/components/managers/_HolidayForm.jsx